import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { configService } from "@/settings/api-url";

// Helpers
import { isMissingDocumentInformation } from "@/plugins/user_helper";

@Component
export default class DashboardSidebar extends Vue {
  @Getter getUser: any;

  isSidebarOpen = false;

  get isShowingMissingDocumentNotification() {
    return isMissingDocumentInformation(this.getUser);
  }

  mounted() {
    this.$emit("onShowSidebar", this.isSidebarOpen);
  }

  navigateTo(routeName: string) {
    if (this.$route.name !== routeName) this.$router.push({ name: routeName });
    if (this.isSidebarOpen) {
      this.toggleSidebar();
    }
    document
      .getElementById("SubscriptionDashboard")
      .scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.$emit("onShowSidebar", this.isSidebarOpen);
  }

  onLogout() {
    delete configService.defaults.headers.common["Authorization"];
    localStorage.clear();
    this.$router.go(0);
  }
}
